/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid, typography2 } from '@coursera/cds-core';

import { usePageHeaderHeight } from 'bundles/composable-page-header/contexts/PageHeaderHeightContext';
import GetS12nCertificateBanner from 'bundles/enroll-common/components/common/GetS12nCertificateBanner';
import type { GetS12nCertificateBannerProps } from 'bundles/page/types/Program';

const BANNER_HEIGHT = 80;

type Props = {
  getS12nCertificateBannerProps?: GetS12nCertificateBannerProps;
};

const styles = {
  banner: css`
    .rc-GetS12nCertificateBanner {
      p {
        font: ${typography2.bodyPrimary.font};
      }

      button,
      a {
        font: ${typography2.actionPrimary.font};
      }
    }
  `,
  wrapper: css`
    margin-left: auto;
    margin-right: auto;
    max-width: 1440px;
    width: 100%;
  `,
};

const LegacyGetS12nCertBannerWrapper = ({ getS12nCertificateBannerProps }: Props) => {
  const pageHeaderHeightContext = usePageHeaderHeight();
  const { s12nSlug } = getS12nCertificateBannerProps || {};

  if (!s12nSlug) return null;

  const addHeight = (legacyArg: string) => {
    if (!pageHeaderHeightContext) {
      return;
    }
    pageHeaderHeightContext.setHeight(pageHeaderHeightContext.height + BANNER_HEIGHT);
  };

  const removeHeight = (legacyArg: string) => {
    if (!pageHeaderHeightContext) {
      return;
    }
    pageHeaderHeightContext.setHeight(pageHeaderHeightContext.height - BANNER_HEIGHT);
  };

  return (
    <Grid container css={styles.wrapper}>
      <Grid item xs={12} css={styles.banner}>
        <GetS12nCertificateBanner
          addParentHeightClass={addHeight}
          removeParentHeightClass={removeHeight}
          s12nSlug={s12nSlug}
        />
      </Grid>
    </Grid>
  );
};

export default LegacyGetS12nCertBannerWrapper;
